import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_get_billing_rate_usageService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { billing_rate_id: number }): 
  Promise<{ result: { Id?: number, BillingRecords?: { BillingRateId?: number }[], BillingForecastRecords?: { BillingRateId?: number }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.billing_rate_id)) {
      $missingRequiredInParams.push('\'billing_rate_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { billing_rate_id: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, BillingRecords?: { BillingRateId?: number }[], BillingForecastRecords?: { BillingRateId?: number }[] }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.billing_rate_id)) {
      $missingRequiredInParams.push('\'billing_rate_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { billing_rate_id: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, BillingRecords?: { BillingRateId?: number }[], BillingForecastRecords?: { BillingRateId?: number }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.billing_rate_id)) {
      $missingRequiredInParams.push('\'billing_rate_id\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      billing_rate_id: number    }) {
        if(isNil($inParams.billing_rate_id)) {
          return true; 
        }
      return false;
    }
}
